import { render, staticRenderFns } from "./loadcarrierlabellist.vue?vue&type=template&id=9af5145e&scoped=true&"
import script from "./loadcarrierlabellist.vue?vue&type=script&lang=js&"
export * from "./loadcarrierlabellist.vue?vue&type=script&lang=js&"
import style0 from "./loadcarrierlabellist.vue?vue&type=style&index=0&id=9af5145e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af5145e",
  null
  
)

export default component.exports